<!--
Provides a very basic ID link
Implement ID + Name for routing to work
Also has a slot to replace the default button
-->
<template>
  <router-link-guard
    :to="{ name, params: { id } }"
    :target="target"
    :can="can"
  >
    <slot>
      <v-btn
        elevation="0"
        small
      >
        {{ display || id }}
      </v-btn>
    </slot>
  </router-link-guard>
</template>

<script>
import RouterLinkGuard from './RouterLinkGuard.vue'

export default {
  name: 'RouterLinkId',
  components: { RouterLinkGuard },
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    display: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: '_self'
    },
    can: {
      type: String,
      default: null
    }
  }
}
</script>
